<template lang="pug">
  .content
    ui-navbar-panel(title="Статистика")
    pre
      | {{ statistics }}
</template>

<script>
import api from '@/api';

export default {
  name: 'view-cron-statistics',

  data: () => ({
    statistics: [],
  }),

  methods: {
    loadStatistics() {
      api
        .for('cron-server')
        .read('statistics')
        .then(({data}) => {
          console.log(data);
          this.settings = data;
        });
    },
  },

  created() {
    this.loadStatistics();
  },
};
</script>
